import * as validation from '@/util/validation'
import * as common from '@/util/common'
import * as _ from 'lodash'

/**
 * QA一覧APIの詳細検索用のリクエストパラメータを生成する
 * @param {object} data QA詳細検索設定データJSONをパースしたデータ
 */
export const createQAListParamsOfSearchDetails = (data) => {

  // 数値型に変換する
  // (APIからのレスポンスの値で数値が文字列型になっている場合があるため、型変換を行う。)
  const toNumber = (value) => {
    if (typeof value === 'number') {
    } else if (typeof value === 'string') {
      if (value.match(/^[0-9]+$/)) {
        value = Number(value)
      } else {
        value = 0
      }
    } else {
      value = 0
    }
    return value
  }

  const listParams = {}

  // 表記の揺れを含む
  listParams.is_fuzzy = toNumber(data.is_fuzzy)

  // 検索タイプ
  listParams.search_type = data.search_type ?? 'keyword'

  // タブ1
  if (data.search_type === 'keyword') {
    // 検索キーワード(キーワード検索の場合)
    if (typeof data.search_text !== 'undefined') {
      listParams.search_text = data.search_text
    } else {
      listParams.search_text = ''
    }
    // 除外キーワード(キーワード検索の場合)
    if (typeof data.excluding_text !== 'undefined') {
      listParams.excluding_text = data.excluding_text
    } else {
      listParams.excluding_text = ''
    }
  } else if (data.search_type === 'andor') {
    // 検索キーワードリスト(AND/OR検索の場合)
    if (typeof data.search_text !== 'undefined' && Array.isArray(data.search_text)) {
      // ストアに保持する場合はsearch_text（単数形）に配列で設定される（APIのリクエストパラメータの仕様に合わせている）
      listParams.search_text = data.search_text
    } else if (typeof data.search_texts !== 'undefined' && Array.isArray(data.search_texts)) {
      // 詳細検索を実行した場合
      listParams.search_text = data.search_texts
    }
    // 除外キーワードリスト(AND/OR検索の場合)
    if (typeof data.excluding_text !== 'undefined' && Array.isArray(data.excluding_text)) {
      // ストアに保持する場合はsearch_text（単数形）に配列で設定される（APIのリクエストパラメータの仕様に合わせている）
      listParams.excluding_text = data.excluding_text
    } else if (typeof data.excluding_texts !== 'undefined' && Array.isArray(data.excluding_texts)) {
      // 詳細検索を実行した場合
      listParams.excluding_text = data.excluding_texts
    }
  }

  // パッケージ
  if (typeof data.packages !== 'undefined') {
    const packages4Param = []
    for (let i = 0; i < data.packages.length; i++) {
      const packageId = data.packages[i].id
      const searchIndexId = data.packages[i].search_index_id
      const map = {
        id: Number(packageId),
        search_index_id: Number(searchIndexId)
      }
      packages4Param.push(map)
    }
    if (packages4Param.length > 0) {
      listParams.packages = packages4Param
    }
  }

  // 書籍
  if (typeof data.book_ids !== 'undefined') {
    // 詳細検索で、書籍IDを指定して検索したものに対して、
    // 保存検索条件、検索履歴から遷移してきた場合、ここにくる。

    let bookIds = data.book_ids
    // book_ids=[1]で検索すると
    // 保存検索条件からは["1"](配列)で戻り、検索履歴からは"["1"]"(文字列)で返ってくるようである
    // よって、まずはJSONエンコードを行い["1"](配列)に統一する

    if (typeof data.book_ids !== 'undefined') {
      try {
        bookIds = JSON.parse(bookIds)
      } catch (e) {
      }
    }

    // ※ストアからbook_idsを直接取得しようとしたら、
    // 　書籍IDが1件の場合に、数値の配列であるべきところ数値で返ってきて、検索結果が正しくないという問題が発生した。
    // 　そこで、common.toArray()メソッドで、数値の場合は、数値の配列に変換する処理を入れて対応することにした。
    bookIds = common.toArray(bookIds)

    // 各要素の値を文字列から数値に変換する
    for (let i = 0; i < bookIds.length; i++) {
      bookIds[i] = Number(bookIds[i])
    }
    listParams.book_ids = bookIds

  } else if (typeof data.books !== 'undefined') {
    // 詳細検索実行時は、booksに書籍IDが設定されている
    const bookIds4Param = []
    for (let i = 0; i < data.books.length; i++) {
      const bookId = data.books[i].id
      bookIds4Param.push(bookId)
    }
    if (bookIds4Param.length > 0) {
      listParams.book_ids = bookIds4Param
    }

    delete data.books
  }

  // 関連法令
  if (typeof data.laws !== 'undefined') {
    if (Object.keys(data.laws).length > 0) {

      if (typeof data.laws.type !== 'undefined') {
        data.laws.type = toNumber(data.laws.type)
      }

      if (typeof data.laws.article1 !== 'undefined') {
        data.laws.article1 = toNumber(data.laws.article1)
      }
      if (typeof data.laws.article2 !== 'undefined') {
        data.laws.article2 = toNumber(data.laws.article2)
      }
      if (typeof data.laws.article3 !== 'undefined') {
        data.laws.article3 = toNumber(data.laws.article3)
      }
      if (typeof data.laws.article4 !== 'undefined') {
        data.laws.article4 = toNumber(data.laws.article4)
      }

      if (typeof data.laws.group1 !== 'undefined') {
        if (typeof data.laws.group1.article1 !== 'undefined') {
          data.laws.group1.article1 = toNumber(data.laws.group1.article1)
        }
        if (typeof data.laws.group1.article2 !== 'undefined') {
          data.laws.group1.article2 = toNumber(data.laws.group1.article2)
        }
        if (typeof data.laws.group1.article3 !== 'undefined') {
          data.laws.group1.article3 = toNumber(data.laws.group1.article3)
        }
        if (typeof data.laws.group1.article4 !== 'undefined') {
          data.laws.group1.article4 = toNumber(data.laws.group1.article4)
        }
      }

      if (typeof data.laws.group2 !== 'undefined') {
        if (typeof data.laws.group2.article1 !== 'undefined') {
          data.laws.group2.article1 = toNumber(data.laws.group2.article1)
        }
        if (typeof data.laws.group2.article2 !== 'undefined') {
          data.laws.group2.article2 = toNumber(data.laws.group2.article2)
        }
        if (typeof data.laws.group2.article3 !== 'undefined') {
          data.laws.group2.article3 = toNumber(data.laws.group2.article3)
        }
        if (typeof data.laws.group2.article4 !== 'undefined') {
          data.laws.group2.article4 = toNumber(data.laws.group2.article4)
        }
      }

      if (typeof data.laws.group3 !== 'undefined') {
        if (typeof data.laws.group3.from_article1 !== 'undefined') {
          data.laws.group3.from_article1 = toNumber(data.laws.group3.from_article1)
        }
        if (typeof data.laws.group3.from_article2 !== 'undefined') {
          data.laws.group3.from_article2 = toNumber(data.laws.group3.from_article2)
        }
        if (typeof data.laws.group3.from_article3 !== 'undefined') {
          data.laws.group3.from_article3 = toNumber(data.laws.group3.from_article3)
        }
        if (typeof data.laws.group3.from_article4 !== 'undefined') {
          data.laws.group3.from_article4 = toNumber(data.laws.group3.from_article4)
        }

        if (typeof data.laws.group3.to_article1 !== 'undefined') {
          data.laws.group3.to_article1 = toNumber(data.laws.group3.to_article1)
        }
        if (typeof data.laws.group3.to_article2 !== 'undefined') {
          data.laws.group3.to_article2 = toNumber(data.laws.group3.to_article2)
        }
        if (typeof data.laws.group3.to_article3 !== 'undefined') {
          data.laws.group3.to_article3 = toNumber(data.laws.group3.to_article3)
        }
        if (typeof data.laws.group3.to_article4 !== 'undefined') {
          data.laws.group3.to_article4 = toNumber(data.laws.group3.to_article4)
        }
      }

      listParams.laws = data.laws
    }
  }

  // 裁判情報
  if (typeof data.judgement !== 'undefined') {
    const judgement4Parmas = {}

    judgement4Parmas.court_names = data.judgement.court_names
    judgement4Parmas.era = data.judgement.era
    judgement4Parmas.year = toNumber(data.judgement.year)
    judgement4Parmas.month = toNumber(data.judgement.month)
    judgement4Parmas.mday = toNumber(data.judgement.mday)
    judgement4Parmas.restriction = toNumber(data.judgement.restriction)
    if (judgement4Parmas.restriction === 2) {
      // 2=期間指定の場合
      judgement4Parmas.end_era = data.judgement.end_era
      judgement4Parmas.end_year = toNumber(data.judgement.end_year)
      judgement4Parmas.end_month = toNumber(data.judgement.end_month)
      judgement4Parmas.end_mday = toNumber(data.judgement.end_mday)
    } else {
      // 2=期間指定以外の場合
      judgement4Parmas.end_era = ''
      judgement4Parmas.end_year = 0
      judgement4Parmas.end_month = 0
      judgement4Parmas.end_mday = 0
    }
    listParams.judgement = judgement4Parmas
  }

  // 事件名
  if (typeof data.case_name !== 'undefined') {
    listParams.case_name = data.case_name
  }

  return listParams
}


/**
 * 絞り込みツリー：自分以下の子要素全てのチェック状態を設定する
 */
const setAllChildrenCheckRecursively = (node, isChecked) => {

  if (typeof node.isChecked !== 'undefined') {
    node.isChecked = isChecked
  }

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      setAllChildrenCheckRecursively(node.packages[i], isChecked)
    }
  } else if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      setAllChildrenCheckRecursively(node.products[i], isChecked)
    }
  } else if (typeof node.books !== 'undefined') {
    for (let i = 0; i < node.books.length; i++) {
      setAllChildrenCheckRecursively(node.books[i], isChecked)
    }
  }
}

/**
 * 絞り込みツリー：同階層の全要素がチェックされていたら親要素をチェックする。
 * そうれでなければ、親要素のチェックを外す
 */
export const setParentNodeCheckStatusRecursively = (node, parentNodeMap) => {

  let parentNodeMapKey = ''
  if (node.itemType === 'package') {
    parentNodeMapKey = 'package_' + node.package_id
  } else if (node.itemType === 'product') {
    parentNodeMapKey = 'product_' + node.product_id
  } else if (node.itemType === 'book') {
    parentNodeMapKey = 'book_' + node.product_id + '_' + node.book_id
  }
  const parentNode = parentNodeMap[parentNodeMapKey]

  if (parentNode) {

    let isAllChecked = true
    if (node.itemType === 'package') {
      // パッケージより上は無いので終了
      return
    } else if (node.itemType === 'product') {
      for (let i = 0; i < parentNode.products.length; i++) {
        if (!parentNode.products[i].isChecked) {
          isAllChecked = false
          break
        }
      }
    } else if (node.itemType === 'book') {
      for (let i = 0; i < parentNode.books.length; i++) {
        if (!parentNode.books[i].isChecked) {
          isAllChecked = false
          break
        }
      }
    }

    parentNode.isChecked = isAllChecked

    if (parentNode.itemType === 'product' || parentNode.itemType === 'book') {
      // さらに上の階層に進む
      setParentNodeCheckStatusRecursively(parentNode, parentNodeMap)
    }
  }
}

/**
 * 絞り込みツリー：チェック状態を伝播させる：ステップ１
 * 対象ノードの子要素全てのチェック状態を設定する
 */
const _propagateCheckedRecursivelyStep1 = (node, targetNodeId, parentNodeMap) => {
  
  const isTargetNode = (node.id === targetNodeId)

  if (isTargetNode) {
    // 対象ノードだった場合
    // 対象ノードの子要素全てのチェック状態を設定する
    setAllChildrenCheckRecursively(node, node.isChecked)
  } else {
    // 対象ノードでなかった場合
    if (typeof node.packages !== 'undefined') {
      for (let i = 0; i < node.packages.length; i++) {
        _propagateCheckedRecursivelyStep1(node.packages[i], targetNodeId, parentNodeMap)
      }
    } else if (typeof node.products !== 'undefined') {
      for (let i = 0; i < node.products.length; i++) {
        _propagateCheckedRecursivelyStep1(node.products[i], targetNodeId, parentNodeMap)
      }
    } else if (typeof node.books !== 'undefined') {
      for (let i = 0; i < node.books.length; i++) {
        _propagateCheckedRecursivelyStep1(node.books[i], targetNodeId, parentNodeMap)
      }
    }
  }
}

/**
 * 絞り込みツリー：チェック状態を伝播させる：ステップ２
 * 同階層の全要素がチェックされていたら親要素をチェックする。そうれでなければ、親要素のチェックを外す。
 */
const _propagateCheckedRecursivelyStep2 = (node, targetNodeId, parentNodeMap) => {
  
  // 同階層の全要素がチェックされていたら親要素をチェックする。
  // そうれでなければ、親要素のチェックを外す。
  setParentNodeCheckStatusRecursively(node, parentNodeMap)

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      _propagateCheckedRecursivelyStep2(node.packages[i], targetNodeId, parentNodeMap)
    }
  } else if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      _propagateCheckedRecursivelyStep2(node.products[i], targetNodeId, parentNodeMap)
    }
  } else if (typeof node.books !== 'undefined') {
    for (let i = 0; i < node.books.length; i++) {
      _propagateCheckedRecursivelyStep2(node.books[i], targetNodeId, parentNodeMap)
    }
  }
}

/**
 * 絞り込みツリー：チェック状態を伝播させる
 */
export const propagateCheckedRecursively = (node, targetNodeId, parentNodeMap) => {
  _propagateCheckedRecursivelyStep1(node, targetNodeId, parentNodeMap)
  _propagateCheckedRecursivelyStep2(node, targetNodeId, parentNodeMap)
}

/**
 * 絞り込みツリーのチェックされているノードのitemTypeとIDのリストを取得する
 */
export const getCheckedNodeItemTypeAndIds = (node, checkedNodeItemTypeAndIds) => {

  if (node.isChecked) {
    let itemTypeAndId = ''
    if (node.itemType === 'package') {
      itemTypeAndId = node.itemType + '_' + node.package_id
    } else if (node.itemType === 'product') {
      itemTypeAndId = node.itemType + '_' + node.product_id
    } else if (node.itemType === 'book') {
      itemTypeAndId = node.itemType + '_' + node.book_id
    }
    checkedNodeItemTypeAndIds.push(itemTypeAndId)
  }

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      getCheckedNodeItemTypeAndIds(node.packages[i], checkedNodeItemTypeAndIds)
    }
  }
  if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      getCheckedNodeItemTypeAndIds(node.products[i], checkedNodeItemTypeAndIds)
    }
  }
}

/**
 * itemTypeとIDのリストにより、絞り込みツリーのチェック状態を設定する
 */
export const setNodeCheckByItemTypeAndIds = (node, checkedNodeItemTypeAndIds) => {
  // const itemTypeAndId = node.itemType + '_' + 

  let itemTypeAndId = ''
  if (node.itemType === 'package') {
    itemTypeAndId = node.itemType + '_' + node.package_id
  } else if (node.itemType === 'product') {
    itemTypeAndId = node.itemType + '_' + node.product_id
  } else if (node.itemType === 'book') {
    itemTypeAndId = node.itemType + '_' + node.book_id
  }

  let isFound = false
  for (let i = 0; i < checkedNodeItemTypeAndIds.length; i++) {
    if (itemTypeAndId === checkedNodeItemTypeAndIds[i]) {
      isFound = true
      break
    }
  }
  if (isFound) {
    node.isChecked = true
  }

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      setNodeCheckByItemTypeAndIds(node.packages[i], checkedNodeItemTypeAndIds)
    }
  }
  if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      setNodeCheckByItemTypeAndIds(node.products[i], checkedNodeItemTypeAndIds)
    }
  }
}

/**
 * チェックされた書籍IDの一覧を取得する
 * @param {Array} checkedBookIds [INPUT/OUTPUT] 書籍IDの配列(参照渡し)
 * @return void
 */
export const getCheckedBookIds = (node, checkedBookIds) => {

  if (typeof node.itemType !== 'undefined') {
    if (node.itemType === 'book') {
      if (node.isChecked) {
        const myBookId = node.book_id ?? 0
        if (myBookId !== 0) {
          checkedBookIds.push(myBookId)
        }
      }
    }
  }

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      getCheckedBookIds(node.packages[i], checkedBookIds)
    }
  }
  if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      getCheckedBookIds(node.products[i], checkedBookIds)
    }
  }
  if (typeof node.books !== 'undefined') {
    for (let i = 0; i < node.books.length; i++) {
      getCheckedBookIds(node.books[i], checkedBookIds)
    }
  }
}


/**
 * チェックされた商品IDの一覧を取得する
 * @param {Array} checkedProductIds [INPUT/OUTPUT] 商品IDの配列(参照渡し)
 * @return void
 */
export const getCheckedProductIds = (node, checkedProductIds) => {

  if (typeof node.itemType !== 'undefined') {
    if (node.itemType === 'product') {
      if (node.isChecked) {
        const myProductId = node.product_id ?? 0
        if (myProductId !== 0) {
          checkedProductIds.push(myProductId)
        }
      }
    }
  }

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      getCheckedProductIds(node.packages[i], checkedProductIds)
    }
  }
  if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      getCheckedProductIds(node.products[i], checkedProductIds)
    }
  }
}

/**
 * チェックされた書籍の商品ID＆書籍IDの一覧を取得する
 * @param {Object} node ツリーのノード
 * @param {Array} idMapListOfCheckedBooks [INPUT/OUTPUT] 商品ID＆書籍IDの配列(参照渡し)
 * @return void
 */
export const getIdMapListOfCheckedBooks = (node, idMapListOfCheckedBooks) => {

  if (typeof node.itemType !== 'undefined') {
    if (node.itemType === 'book') {
      if (node.isChecked) {
        const productId = node.product_id ?? 0
        const bookId = node.book_id ?? 0
        if (productId !== 0 && bookId !== 0) {
          const map = {
            product_id: productId,
            book_id: bookId
          }
          idMapListOfCheckedBooks.push(map)
        }
      }
    }
  }

  if (typeof node.packages !== 'undefined') {
    for (let i = 0; i < node.packages.length; i++) {
      getIdMapListOfCheckedBooks(node.packages[i], idMapListOfCheckedBooks)
    }
  }
  if (typeof node.products !== 'undefined') {
    for (let i = 0; i < node.products.length; i++) {
      getIdMapListOfCheckedBooks(node.products[i], idMapListOfCheckedBooks)
    }
  }
  if (typeof node.books !== 'undefined') {
    for (let i = 0; i < node.books.length; i++) {
      getIdMapListOfCheckedBooks(node.books[i], idMapListOfCheckedBooks)
    }
  }
}
